export default __webpack_public_path__ + "static/media/26.4fad7a9e.jpg";